import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4033010"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon" }, null, -1))
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrapper = _resolveComponent("message-wrapper")!

  return (_openBlock(), _createBlock(_component_message_wrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["align-items-center message-container error", {
        'float-end': _ctx.message.isUserMessage(),
        'user-message': _ctx.message.isUserMessage()
      }])
      }, [
        _hoisted_1,
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.lines, (line, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              innerHTML: _ctx.getSafeHtml(line)
            }, null, 8, _hoisted_2))
          }), 128))
        ])
      ], 2)
    ]),
    _: 1
  }))
}